import './App.css';
import { use, useEffect, useMemo, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry, TooltipModule } from 'ag-grid-community'; 
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { getTTFB } from 'web-vitals';
import DiamondIcon from '@mui/icons-material/Diamond';
import Nfc from '@mui/icons-material/Nfc';
import { green } from '@mui/material/colors';
import { Modal,Box,TextField, IconButton, Switch } from '@mui/material';
import { isLabelWithInternallyDisabledControl } from '@testing-library/user-event/dist/utils';
import { Margin, Padding, Search } from '@mui/icons-material';
import errorsound from './errorsound_short.mp3';
import successsound from './success.mp3';
import existsound from './exist.mp3';
import { Refresh,DocumentScanner,InvertColors} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MyToast from './MyToast';

import { themeQuartz } from 'ag-grid-community';
/*import Typography from '@mui/material/Typography';
import { Switch } from '@mui/material';
import { Dash } from './LoadPage';
import { DashShow } from './ShowPage';*/

ModuleRegistry.registerModules([TooltipModule,AllCommunityModule]);

//https://pixabay.com/sound-effects/search/ding/
//yarn build && scp -r build/* debian@vps-d8de5077.vps.ovh.net:/var/www/html/inventario/.

const wsbase = "https://inventario.affarintech.com/wsinv";

const doorurl = wsbase+"/getrfiddb";
const inventoryantennaurl = wsbase+"/inventoryantennaobjs";
const corourl = wsbase+"/getarticolicoro";
const coronotexisturl = wsbase+"/getarticolicoronotexist";
const singlewrite = wsbase+"/confirmtodb";
const multiplewrite = wsbase+"/multipleconfirmtodb";


const style = {
  position: 'absolute',
  top: '20%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #578',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const rfidobject = {
  tagid:null,
  barcode: "1000000000000",
  artid: ""
}


const scantheme = themeQuartz.withParams({
  fontSize:18,
  headerFontSize:16,
});

const diff_time_scan = (15*24*60*60*1000); // 15 day, 24 hours, 60 minutes, 60 seconds, 1000 ms .

function App() {
  
  //const [us,setUs]=useState();
  const [scantype, setScantype] = useState(true);

  const [inventory,setInventory] = useState([]);
  const [rowData, setRowData] = useState([]);

  const [notfound, setNotfound] = useState(0);
  const [notexist, setNotExist] = useState([]);

  const [colDefs, setColDefs] = useState([]);
  const [foundobjs, setFoundobj] = useState([]); 
  const [newtags, setNewtags] = useState([]);

  const [scanmode, setScanMode] = useState(false);
  const [scanobj, setScanobj] = useState([]);
  const [toastopen,setToastOpen] = useState(false);
  
  const [msg, setMessage] = useState("ready");

  const [scanColDefs, setScanColDef]= useState( [
    { headerName: "Numero", field: "index", width:100,sortable:true},
    { headerName: "Descrizione", field: "descrizione",width:400,sortable:false },
    { field: "codice", width:90,sortable:false },
    { field: "barcode",width:90,sortable:false },
    { field: "tagrfid",width:90,sortable:false },
  ]);

  const [alternateColor,setAlternateColor] = useState(false);
  
  /*  { headerName: "Descrizione", field: "descrizione", tooltipValueGetter: (p)=>{
      let ret = inventory.filter( s => s.tagid===p.data.tagrfid).map( o => o.readtime );
      if(ret.length==0)
        return 'non scansionato';
      return p.data.tagrfid;
    } },
    { headerName: "Peso", field: "peso" },
    { field: "barcode" },
    { field: "tagrfid" }
  ]);*/

  const normchecked = {
    'checked': params => {
      let found = inventory.filter( r => r.tagid===params.data.tagrfid ).length>0;
      return found;
    }
  };

  const altchecked = {
    'checked': params => {
      let found = inventory.filter( r => r.tagid===params.data.tagrfid ).length>0;
      if(found){
        let dt = inventory.filter( r => r.tagid===params.data.tagrfid ).map( o => o.readtime)[0];
        let diffnow =  new Date().getTime() - dt;
        if(diffnow>diff_time_scan){
          return false;
        }
      }
      if(alternateColor){
        return found&&(params.node.rowIndex%2===0);
      }else{
        return found;
      }
    },
    'checked-blue': params=>{
      let found = inventory.filter( r => r.tagid===params.data.tagrfid ).length>0;
      if(found){
        let dt = inventory.filter( r => r.tagid===params.data.tagrfid ).map( o => o.readtime)[0];
        let diffnow =  new Date().getTime() -dt;
        if(diffnow>diff_time_scan){
          return false;
        }
      }
      if(alternateColor){
        return found&&(params.node.rowIndex%2===1);
      }else{
        return false;
      }
    }
  };

  

  useEffect( ()=>{
    if(inventory.length>0){
      getrfidobj();
      getrfidobjnotexist();
    }
  },[inventory]);

  useEffect( () => {
    let onlytags = rowData.map( o => o.tagrfid );
    let notinobjs = inventory.map( o => o.tagid ).map( tg => onlytags.includes(tg)?0:1 ).reduce( (a,c) => a+c,0);
    setNotfound(notinobjs);
  }
  ,[rowData]);

  const SoundExist = new Audio(existsound);
  SoundExist.loop = false;

  const SoundNotExist = new Audio(errorsound);
  SoundNotExist.loop = false;

  const SoundSuccess = new Audio(successsound);
  SoundSuccess.loop = false;

  const modalhandleOpen = () => {
    setScanobj([]);
    setFoundobj([]);
    setScanMode(!scanmode);
  }

  //const modalhandleClose = () => setOpen(false);

  /*const loadmodal = ()=>{
    return (<Modal open={true} onClose={modalhandleClose}>
      <Box>
        <h4>Load rfid</h4>
        <TextField id="rfidtext" size="small" label="RFID" variant="outlined" onChange={(e)=>console.log(e.target.val)}/>
        <TextField id="barcodetext" size="small" label="BARCODE" variant="outlined" />
      </Box>
    </Modal>)
    
  }*/

  // https://www.ag-grid.com/react-data-grid/filter-date/
  const getrfidobj = ()=>{
    fetch(corourl).then( (response) => response.json().then( objs => {
        setColDefs([
          { filter: true ,sortable: true, headerName: "Descrizione", field: "descrizione", tooltipValueGetter: (p)=>{
            let ret = inventory.filter( s => s.tagid===p.data.tagrfid).map( o => o.readtime );
            if(ret.length==0)
              return 'non scansionato';
            return 'scansionanto il '+new Date(ret[0]).toLocaleDateString("it-IT");
          } },
          { headerName: "Peso", field: "peso" },
          { filter: true, field: "codice" },
          { filter: true, field: "barcode" },
          { filter: true, field: "tagrfid" },
          { filter: true, filed: "readtime", 
            headerName:"Data ultima scansione", valueGetter: p => {
              let dt = inventory.filter( r => r.tagid===p.data.tagrfid ).map( o => o.readtime)[0];
              if (dt!==undefined){
                return new Date(dt).toISOString().split("T")[0];
                //return new Date(dt).toLocaleDateString("it-IT");
              }
              return "";
          }},
        ]);
        setRowData(objs);
      })
    ).catch( err => console.log(err));

  }

  const getrfidobjnotexist = ()=>{
    fetch(coronotexisturl).then( (response) => response.json().then( objs => {
        setNotExist(objs);
      })
    ).catch( err => console.log(err));

  }

  const postrfidobj = (rfido)=>{
    fetch(singlewrite, {
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(rfido)  
    })
    .then( (response) => response.json() )
    .then( objs => {
        console.log(objs);
        setMessage("Object loaded");
        getintegratedantenna();
    })
    .catch( err => {
      console.log(err);
      setMessage("Error on load");
      getintegratedantenna();
    });
  }

  useEffect(()=>{
    if(newtags.length>0){
      newtags.forEach( fobj =>{
        if(inventory.length>0){
          //let isInventored = inventory.find( i => i.tagid===fobj);
          let lastInventored = inventory
            .filter( obj => (obj.tagid===fobj) && ( (new Date().getTime() - obj.readtime) < diff_time_scan) ).length;
          if(lastInventored>0){
            console.log("item is inventored and updated");
            SoundExist.play(); 
          } else {
            console.log("item to inventory or update");
            rfidobject.tagid = fobj;
            SoundSuccess.play();
            postrfidobj(rfidobject);
          }
          //SoundNotExist.play();
        }
      });
    }
  },[newtags]);
  
  const getintegratedantenna = ()=>{
    fetch(inventoryantennaurl).then( (response) => response.json()
    .then( objs => {
        setInventory(objs);
      })
    ).catch( err => console.log(err));
  }

  /*const codesearch = useMemo(()=>{
    if(d!==undefined){
      return rowData.filter( o => o.tagrfid===d.tagid ).length>0;
    }
    return false;
  },[rowData]);*/


  useEffect(()=>{
    if(scanobj instanceof Array){
      console.log("search on  "+scanobj.length+"/"+rowData.length);
      let fobj = scanobj.map( searchtext => {
        let foundobj ={ 
          index:null,
          tagrfid:"",
          barcode:"",
          descrizione:"",
          codice:"",
          readtime:null
        };
        let tgf = rowData.find( o => o.tagrfid.toLowerCase()===searchtext);
        let bcode = rowData.find( o => o.barcode===searchtext);
        let cod = rowData.find( o => o.codice.toLowerCase()===searchtext);
        
        if(tgf){
          console.log("found rfidtag "+searchtext);
          foundobj.tagrfid=searchtext;
          foundobj.barcode=tgf.barcode;
          foundobj.descrizione=tgf.descrizione.toUpperCase();
          foundobj.codice=tgf.codice;
          return foundobj;
        }
        if(bcode){
          console.log("found barcode "+searchtext);
          foundobj.tagrfid=bcode.tagrfid;
          foundobj.barcode=searchtext;
          foundobj.codice=bcode.codice;
          foundobj.descrizione=bcode.descrizione.toUpperCase();
          return foundobj;
        }
        if(cod){
          console.log("found codice "+searchtext);
          foundobj.tagrfid=cod.tagrfid;
          foundobj.barcode=cod.barcode;
          foundobj.codice=searchtext;
          foundobj.descrizione=cod.descrizione.toUpperCase();
          return foundobj;
        }
      });
      let valid = fobj.filter(oj=> oj!==undefined);
      let oldtgid = new Set(foundobjs.map( f => f.tagrfid ));
      let newtgid = new Set(valid.map( l => l.tagrfid));
      let diffs = newtgid.difference(oldtgid);
      
      
      //setNewtags(newtgid);
      if(diffs.size>0){
        /* last in, first out */
        valid.reverse();

        /* numerize all objs */
        valid.map( (o,indx)=>o.index=indx);

        setNewtags([...diffs]);
        setFoundobj(valid);
      }
    }
  },[scanobj])


  const isEnter = (e)=>{
    
    if(e.keyCode === 13){
      console.log("send data to db");
      let ts = document.getElementById("codetext");
      
      if(ts!==null){
        //rfidobject.tagid = 
        const vl = ts.value.toLowerCase().replaceAll(" ","");
        ts.value="";
        //console.log("send "+JSON.stringify(rfidobject)+" to db");
        setScanobj(Array.from(new Set([...scanobj,vl])));
        //SoundNotExist.play();
        //if(inventory instanceof Array){

          /*if(inventory.filter( o => o.tagid===rfidobject.tagid ).length>0){
            console.log("rfid exist");
            SoundExist.play();
            return;    
          }*/
          //if(rfidsearch(rfidobject)){
          //console.log("rfid to db");
          //SoundSuccess.play();
          //postrfidobj(rfidobject);
          //} else {
          //console.log("rfid not exist");
          //  SoundNotExist.play();
         // }
        //}
      }
    }
  };

  const RFIDuntilReturn = (e)=>{
    console.log(e);
  }

  // not used 
  /*const getusb = ()=>{
    navigator.usb
    .requestDevice({ filters: [{ vendorId: 0x303a },{ vendorId: 0x1a86 }] })
    .then((device) => {
      console.log(device.productName); // "Arduino Micro"
      console.log(device.manufacturerName); // "Arduino LLC"
      setUs(device);
    })
    .catch((error) => {
      console.error(error);
    });
  }

  const read = (p) =>{
    const reader = p.readable.getReader();

      // Listen to data coming from the serial device.
      while (true) {
        reader.read().then( (v,d) =>{
          if (d) {
            // Allow the serial port to be closed later.
            reader.releaseLock();
            // value is a Uint8Array.
            console.log(v); 
          }
        })
      }
  }

  const getserial = ()=>{
    navigator.serial.requestPort({ filters: [{ usbVendorId: 0x303a },{ usbVendorId: 0x1a86 }] })
    .then((port) => {
      console.log(port.getInfo()); // "Arduino Micro"

      port.onconnect = read;

      port.open({ baudRate: 115200 }).catch( err => console.log(err));

    })
    .catch((error) => {
      console.error(error);
    });
  }*/

  
  /*
  <Stack direction="row" spacing={1} sx={{ marginTop:0, paddingTop:0, alignItems: 'center' }}>
              <Typography>Barcode</Typography>
                <Switch sx={{display:'flex'}} defaultChecked={scantype} onChange={(s)=>setScantype(s.target.checked)}/>
              <Typography>Rfid</Typography>
          </Stack>
          */

  //https://medium.com/codalyze/2-ag-grid-default-and-custom-sorting-filtering-604115e6af70

  /*useEffect(()=>{
    if(msg!==undefined)
      setToastOpen(true);
  },[msg]);

  setInterval(()=>{
    setMessage("tic");
  },1000);*/

  const inventory_lastscanned = ()=>{
    return inventory.filter( o => {
      let diffnow =  new Date().getTime()- o.readtime;
      return diffnow<diff_time_scan;
    }).length;
    
  };

  return (
    <div className="App">
      <header className="App-header">
      <div>
        <Stack direction='row' spacing={4}>
          <Button startIcon={<Refresh/>} color="success" variant="contained" onClick={()=>getintegratedantenna()}/>
          <Button startIcon={<DocumentScanner/>} color="warning" variant="contained" onClick={()=>modalhandleOpen()}/>
          {!scanmode && (<Switch defaultChecked={alternateColor} onChange={(e)=>setAlternateColor(e.target.checked)}/>)}
        </Stack>
      </div>
      <Divider variant='inset'/>
        {!scanmode && (<Stack spacing={3}>
        <Stack direction="row" spacing={2}>
          <Avatar sx={{ bgcolor: green}} >
            <DiamondIcon />
          </Avatar>
          <Chip style={{background:'white'}} variant="outlined" label={rowData.length} size="medium" /> articoli totali con TAG in CORO,
          <Chip style={{background:'yellow'}} variant="outlined" label={notexist.length} size="medium" /> non esistenti
        </Stack>
        <Stack direction="row" spacing={2}>
          <Avatar sx={{ bgcolor: green}} >
            <Nfc />
          </Avatar>
          <Chip style={{background:'white'}} variant="outlined" label={inventory_lastscanned()} size="medium" /> TAG scansionati, 
          <Chip style={{background:'yellow'}} variant="outlined" label={notfound} size="medium" /> non in CORO
        </Stack>
      </Stack>)}
       {scanmode && (<TextField sx={{marginTop:5}} style={{width:500,marginBottom:5,backgroundColor:"white"}} id="codetext" autoFocus={true} autoComplete={'off'} size="small" label="RFID or Barcode or Cod" onKeyUp={(e)=>isEnter(e)} variant="filled"/>)}
        
      <Divider variant='inset'/>
      
      <div style={{ width: "100%", height: "25em" }}>
        {!scanmode && (<AgGridReact
            rowData={rowData}
            onGridReady={getintegratedantenna}
            columnDefs={colDefs}
            defaultColDef={{flex: 1}}
            rowClassRules={altchecked}
            tooltipShowDelay={500}
        />)}
        {scanmode && (<AgGridReact
            theme={scantheme}
            rowData={foundobjs}
            onGridReady={()=>console.log("show grid ready")}
            columnDefs={scanColDefs}
            rowClassRules={normchecked}
            defaultColDef={{width:'100%'}}
        />)}
      </div>
      <MyToast msg={msg}/>
      </header>
    </div>
  );
}

export default App;
